export const footerStateHandler = (
  state: number,
  hasJustPlaced: boolean,
  isMybetInList: boolean,
  isCashouted: boolean,
  user_id: any,
  isAutoOn: boolean,
  users: any,
  setdisableCancel: (a: boolean) => void,
  setisCashouted: (a: boolean) => void,
  sethasJustPlaced: (a: boolean) => void,
  setfooterState: (a: string) => void,
  setisBetPlacedFromBrowser: (a: boolean) => void,
  placedBet: any,
  betError: any,
) => {
  switch (state) {
    case 1:
      let found = users.some((u: any) => u.id === user_id && !!u.bet)
      setdisableCancel(true)
      setisCashouted(false)
      if (found) {
        sethasJustPlaced(false)
      }
      if (isAutoOn && hasJustPlaced) {
        sethasJustPlaced(false)
        // return setfooterState('cancelAuto')
        return setfooterState("waitForNext") //test
      }
      if (found) {
        if (isAutoOn) {
          // return setfooterState('cancelAuto')
          return setfooterState("waitForNext") //test
        } else {
          return setfooterState("cancelBet")
        }
      }
      if (betError !== 0 && hasJustPlaced) {
        sethasJustPlaced(false)
        // return setfooterState("placeBet")
      }
      if (isAutoOn && betError === 0) {
        return setfooterState("waitForNext")
      }
      break
    case 2:
      setdisableCancel(false)
      if (
        (betError === 112 || betError === 108 || betError === 115) &&
        !isAutoOn
      ) {
        setfooterState("placeBet")
        sethasJustPlaced(false)
      }
      // if (
      //   (placedBet.error.code === 112 || placedBet.error.code === 108) &&
      //   !isAutoOn
      // ) {
      //   setfooterState("placeBet")
      //   sethasJustPlaced(false)
      //   return
      // }
      if (isMybetInList) {
        if (isAutoOn && isCashouted) {
          return setfooterState("cancelAuto")
        }
        if (isAutoOn) {
          return setfooterState("cashoutAuto")
        } else {
          return setfooterState("cashout")
        }
      }
      if (isAutoOn && hasJustPlaced) {
        return setfooterState("cancelAuto")
      }
      if (isCashouted && !isAutoOn) {
        return setfooterState("placeBet")
      }
      if (hasJustPlaced) {
        return setfooterState("cancelBet")
      }

      return setfooterState("placeBet")
    case 3:
      setdisableCancel(false)
      setisBetPlacedFromBrowser(true)
      if (isMybetInList) {
        return setfooterState("ending")
      }
      if (isAutoOn && (isCashouted || hasJustPlaced)) {
        return setfooterState("cancelAuto")
      }
      if (isCashouted) {
        return setfooterState("placeBet")
      }
      if (hasJustPlaced) {
        return setfooterState("cancelBet")
      }
      if (!hasJustPlaced && isAutoOn && !isCashouted) {
        return setfooterState("ending")
      }
      return setfooterState("placeBet")
    default:
      break
  }
}
